$(".custom-ing-tabs").click(function(){
  $(this).parents(".custom-ing-item").find(".custom-ing-tabs-content").hide();
  $(this).parent().find(".custom-ing-tabs").removeClass("active");
  $(this).addClass("active");
  let title = $(this).attr("data-title");
  $(this).parents(".custom-ing-item").find(`.custom-ing-tabs-content[data-title="${title}"]`).fadeIn(300);
})
$(".custom-faq-title").click(function(){
  $(this).toggleClass("active");
  $(this).next(".custom-faq-content").slideToggle(300);
})
$(".custom--top-btn").click(function(e){
  let href = $(this).attr("href");
  if(href.indexOf("#") != -1){
    let top = $(href).offset().top;
    e.preventDefault();
    $("html, body").animate({ scrollTop: top }, 500);
  }
})
$(".cws2-product-checkbox-input").change(function(){
  let cid = document.querySelector('.product-form input[name="id"]').getAttribute("value");
  document.querySelectorAll(".custom-master-li").forEach(function(item){
  if(item.getAttribute("data-vid") == cid){
    if(document.querySelector(".cws2-product-checkbox-input:checked")){
      console.log("hasChcked")
      document.querySelector("#price-button").innerText = item.getAttribute("data-plus-addon-price");
      
      var formData = new FormData();
      let vid = $(".cws2-product-option").attr("data-variant-id");
      formData.append(`updates[${vid}]`, 1);
      
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => console.log(data));
    }
    else{
      console.log("hasntChcked")
      document.querySelector("#price-button").innerText = item.innerText;

      var formData = new FormData();
      let vid = $(".cws2-product-option").attr("data-variant-id");
      formData.append(`updates[${vid}]`, 0);
      
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => console.log(data));
    }
  
  }
  })
})

// document.addEventListener('DOMContentLoaded', function() {
//   class CWS2ProductSelector {
//     constructor() {
//       this.cartItems = new Map();
//       this.initializeEventListeners();
//       this.initializeCartState();
//       document.addEventListener('cart:updated', () => this.handleCartUpdate());
//     }

//     async handleCartUpdate() {
//       await this.initializeCartState();
//       this.updateCheckboxStates();
//     }

//     async initializeCartState() {
//       try {
//         const cart = await fetch('/cart.js').then(res => res.json());
//         this.cartItems.clear();
//         cart.items.forEach(item => {
//           this.cartItems.set(item.variant_id.toString(), item.key);
//         });
//         this.updateCheckboxStates();
//       } catch (error) {
//         console.error('CWS2 Error initializing cart:', error);
//       }
//     }

//     updateCheckboxStates() {
//       document.querySelectorAll('.cws2-product-option').forEach(option => {
//         const variantId = option.dataset.variantId;
//         const checkbox = option.querySelector('.cws2-product-checkbox-input');
//         checkbox.checked = this.cartItems.has(variantId);
//       });
//     }

//     initializeEventListeners() {
//       document.querySelectorAll('.cws2-product-checkbox-input').forEach(checkbox => {
//         checkbox.addEventListener('change', this.handleCheckboxChange.bind(this));
//       });

//       document.querySelectorAll('form[action="/cart/add"] [name="add"]').forEach(button => {
//         button.addEventListener('click', async (e) => {
//           e.preventDefault();
//           await this.handleMainAddToCart();
//         });
//       });
//     }

//     async handleMainAddToCart() {
//       try {
//         // Add main product
//         await this.addMainProduct();
        
//         // Add checked items
//         const checkedVariants = Array.from(document.querySelectorAll('.cws2-product-checkbox-input:checked'))
//           .map(checkbox => checkbox.closest('.cws2-product-option').dataset.variantId);

//         if (checkedVariants.length > 0) {
//           await this.addMultipleToCart(checkedVariants);
//         }

//         await this.updateCartTotal();
//         this.updateCheckboxStates();
//       } catch (error) {
//         console.error('CWS2 Error during add to cart:', error);
//       }
//     }

//     async addMainProduct() {
//       const form = document.querySelector('form[action="/cart/add"]');
//       if (!form) return;

//       const formData = new FormData(form);
//       try {
//         await fetch('/cart/add.js', {
//           method: 'POST',
//           body: formData
//         });
//       } catch (error) {
//         console.error('CWS2 Error adding main product:', error);
//         throw error;
//       }
//     }

//     async addMultipleToCart(variantIds) {
//       try {
//         const items = variantIds.map(id => ({
//           id,
//           quantity: 1,
//           properties: { '_cws2_upsell': 'true' }
//         }));

//         await fetch('/cart/add.js', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({ items })
//         });
//       } catch (error) {
//         console.error('CWS2 Error adding multiple items:', error);
//         throw error;
//       }
//     }

//     async handleCheckboxChange(event) {
//       const checkbox = event.target;
//       const variantId = checkbox.closest('.cws2-product-option').dataset.variantId;
      
//       checkbox.disabled = true;
//       try {
//         if (checkbox.checked) {
//           await this.addProductToCart(variantId);
//         } else {
//           await this.removeProductFromCart(variantId);
//         }
//         await this.updateCartTotal();
//         this.updateCheckboxStates();
//       } catch (error) {
//         console.error('CWS2 Error updating cart:', error);
//       }
//       checkbox.disabled = false;
//     }

//     async addProductToCart(variantId) {
//       try {
//         const response = await fetch('/cart/add.js', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({ id: variantId, quantity: 1 })
//         });
//         const item = await response.json();
//         this.cartItems.set(variantId, item.key);
//       } catch (error) {
//         console.error('CWS2 Error adding product:', error);
//         throw error;
//       }
//     }

//     async removeProductFromCart(variantId) {
//       try {
//         const itemKey = this.cartItems.get(variantId);
//         if (itemKey) {
//           await fetch('/cart/change.js', {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({ id: itemKey, quantity: 0 })
//           });
//           this.cartItems.delete(variantId);
//         }
//       } catch (error) {
//         console.error('CWS2 Error removing product:', error);
//         throw error;
//       }
//     }

//     async updateCartTotal() {
//       try {
//         const cart = await fetch('/cart.js').then(res => res.json());
//         const totalPrice = cart.items.reduce((sum, item) => sum + item.final_line_price, 0);
        
//         document.querySelectorAll('.cart-count-bubble').forEach(element => {
//           element.textContent = cart.item_count;
//         });
        
//         document.querySelectorAll('.cart-price').forEach(element => {
//           element.textContent = Shopify.formatMoney(totalPrice, theme.moneyFormat);
//         });
        
//         document.dispatchEvent(new CustomEvent('cart:updated', {
//           bubbles: true,
//           detail: { cart }
//         }));
//       } catch (error) {
//         console.error('CWS2 Error updating cart total:', error);
//       }
//     }
//   }

//   if (document.querySelector('.cws2-custom-product-selector')) {
//     new CWS2ProductSelector();
//   }
// });

// $(function(){
//   const checkSubInterval = setInterval(checkSub, 100);
//   let found = false;
//   function checkSub() {
//     console.log("finding...")
//     if($(".custom-sub-points-wrapper").length > 0 && $("#trustapps-sub-options").length > 0){
//       console.log("found!!!");
//       clearInterval(checkSubInterval);
//       let subPoints = $(".custom-sub-points-wrapper").detach()
//       $("#trustapps-sub-options .spg-grid").append(subPoints);
//       if(!found){
//         found = true;
//         if($(".spg-price .original-price").length > 0 && $(".spg-price .price-difference").length > 0){
//           let op = parseFloat($(".spg-price .original-price").text().replace("RON", "").trim());
//           let pd = parseFloat($(".spg-price .price-difference").text().replace("RON", "").trim());
//           if(op <= pd){
//             $("#trustapps-sub-options .spg-price").addClass("custom-spg--hide");
//           }
//         }
//       }
//     }
//   }
// })


// $(function () {
//   const checkSubInterval = setInterval(checkSub, 100);

//   function checkSub() {
//     console.log("finding...");
    
//     // Check if both elements exist
//     if ($(".custom-sub-points-wrapper").length > 0 && $(".subify-selling-plan-whole-wrapper").length > 0) {
//       console.log("found!!!");
//       clearInterval(checkSubInterval);

//       // Detach the element to move it
//       let subPoints = $(".custom-sub-points-wrapper").detach();

//       // Append it after .subify-selling-plan-whole-wrapper
//       $(".subify-selling-plan-whole-wrapper").after(subPoints);
//     }
//   }
// });




$(function () {
  const checkSubInterval = setInterval(checkSub, 100);
  setTimeout(function(){
    clearInterval(checkSubInterval);
  }, 6000)

  function checkSub() {
    console.log("finding...");
    
    // Check if both elements exist
    if ($(".custom-sub-points-wrapper").length > 0 && $(".subify-selling-plan-whole-wrapper").length > 0) {
      console.log("found!!!");
      clearInterval(checkSubInterval);

      // Detach the element to move it
      let subPoints = $(".custom-sub-points-wrapper").detach();

      // Append it after .subify-selling-plan-whole-wrapper
      $(".subify-selling-plan-whole-wrapper").after(subPoints);

      // Detach the element to move it
      let onePoints = $(".custom-one-points-wrapper").detach();

      // Append it after .subify-selling-plan-whole-wrapper
      $("#subify-widget-one-time-purchase-text").parents(".subify-choice-box-wrapper").find("div").eq(0).after(onePoints);

      setTimeout(function(){
      $(".product__info-wrapper .product-form__submit #price-button").text($(".subify-choice-box-wrapper.active .subify-choice-price").text());
      }, 500)

      $(document).on("click", ".subify-choice-box-wrapper > div:first-child", function(e){
        e.stopPropagation();
        // console.log("test", $(this).find(".subify-choice-price").text());
        $(".product__info-wrapper .product-form__submit #price-button").text($(this).find(".subify-choice-price").text());
      })
      $(document).on("click", ".subify-selling-plan-option-box", function(e){
        e.stopPropagation();
        // console.log("test", $(this).find(".subify-selling-plan-price").text());
        $(".product__info-wrapper .product-form__submit #price-button").text($(this).find(".subify-selling-plan-price").text());
      })
    }
  }
});

$(".custom-mobile-menu-toggle").click(function(e){
  e.preventDefault();
  $(this).toggleClass("active");
  $(this).next(".custom-mobile-menu-ul").slideToggle(300);
})

$(".custom-search-icon").click(function(){
  $(".custom-search--drawer").addClass("active");
  $(".custom-drawer-overlay").fadeIn(300);
})

$(".new-header-icon").click(function(){
  $(".custom-menu--drawer").addClass("active");
  $(".custom-drawer-overlay").fadeIn(300);
})

$(".custom-drawer-close, .custom-drawer-overlay").click(function(){
  $(".custom-drawer-overlay").fadeOut(300);
  $(".custom-menu--drawer, .custom-search--drawer").removeClass("active");
})

function AddProductsToCart(productsArr, $this){
  $this.addClass("active");
  let formData = {
    'items': productsArr,
    sections: "cart-drawer,cart-icon-bubble"
  };
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'xmlhttprequest'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json();
  })
  .then(res => {
    console.log("response", res);
    if(res.status){
      console.log(res);
    }
    else{
      const cartParsedData = new DOMParser().parseFromString(res.sections['cart-drawer'], 'text/html');
      const cartBubbleParsedData = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html');
      $("cart-drawer.drawer").removeClass("is-empty"); $(".drawer__inner").html($(cartParsedData).find(".drawer__inner").html());
      $("#cart-icon-bubble").html($(cartBubbleParsedData).find(".shopify-section").html());
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  })
  .finally(() => {
    $this.removeClass("active");
  });
}

$(document).on("click", ".custom-drawer-upsell-qty-plus", function(e){
  let qty = parseInt($(this).parent().find(".custom-drawer-upsell-qty-input").val()) + 1;
  $(this).parent().find(".custom-drawer-upsell-qty-input").val(qty);
})

$(document).on("click", ".custom-drawer-upsell-qty-minus", function(e){
  let qty = parseInt($(this).parent().find(".custom-drawer-upsell-qty-input").val());
  if(qty >= 2){
    let fqty = qty - 1;
    $(this).parent().find(".custom-drawer-upsell-qty-input").val(fqty);
  }
})

$(document).on("click", ".custom-drawer-upsell-atc", function(e){
  let arr = [];
  let qty = parseInt($(this).parent().find(".custom-drawer-upsell-qty-input").val());
  arr.push({ 'id': $(this).attr("data-id"), 'quantity': qty });
  AddProductsToCart(arr, $(this));
})

$(document).on("click", ".custom-cart-upgrade", function(){
  let $this = $(this);
  let arr = [];
  arr.push({ 'id': $(this).attr("data-id"), 'quantity': 1 });
  let fvid = $(".custom-cart-first-item").attr("data-vid");
  let formData = {
      'line': 1,
      'quantity': 0
    };
  fetch(window.Shopify.routes.root + 'cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json();
  })
  .then(res => {
    console.log("response", res);
    if(res.status){
      console.log(res);
    }
    else{
      AddProductsToCart(arr, $this);
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  });
})

$(document).on("click", ".subify-choice-wrapper .checkbox-label", function(){
  let span = $(this).children("span").text().toLowerCase().trim();
  console.log(span);
  if(span == 'abonament'){
    console.log("sub")
    $(".sp-price .sp-price-sub").attr("style", "display: inline");
    $(".sp-price .sp-price-single").hide();
  }
  else{
    console.log("single")
    $(".sp-price .sp-price-sub").hide();
    $(".sp-price .sp-price-single").attr("style", "display: inline");
  }
})